import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function CourseHighlights({ eligibility, highlights }) {
  return (
    <>
      <div className="mt-6">
        <div className="text-[11px] font-semibold tracking-[1.4px] uppercase text-slate-500">Eligibility</div>
        <p className="mt-1 text-slate-700">{eligibility}</p>
      </div>
      <ul className="mt-6 space-y-2">
        {highlights.map((h) => (
          <li key={h} className="flex items-start gap-2 text-slate-700">
            <CheckCircle2 size={18} className="text-[var(--pca-blue)] mt-0.5 shrink-0" />
            <span>{h}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
